module.exports = __webpack_public_path__ + "img/hr-green-asterisk-12.c2123022.png";